

/*
vim: fileformat=unix syntax=JavaScript tabstop=4 shiftwidth=4 expandtab fileencoding=utf8
*/
/* jslint browser: true */

import tools from '../js/tools';
import { useNephalemDsproApi } from './plugin_api';
import { useGuiHelper } from './wizard-gui-helper';

let nephalemsignerApi = null;

function LocalPkcs11SignatureHandler(wizardListener, _api) {
    //link to main page to show dialog
    this._guiHelper = useGuiHelper(wizardListener);
    if(!_api) {
        //default api for uniwizard, doclist passes its own implementation
        _api = {
            dynamicAction(params, options, cb) {
                return tools.api('', params, options, cb);
            },
            execApi(command, params, options, cb) {
                return tools.api(command, params, options, cb);
            },
        };
    }
    this._api = _api;
}
LocalPkcs11SignatureHandler.prototype = {
    _guiHelper: null,
    certificate: null,
    init(cb) {
        const self = this;
        if(nephalemsignerApi)
            return cb();
        const _nephalemsignerApi = useNephalemDsproApi(self._guiHelper, self._api);
        self._guiHelper.waiting2(true);
        _nephalemsignerApi.init()
            .then(() => {
                nephalemsignerApi = _nephalemsignerApi;
                self._guiHelper.waiting2(false);
                cb();
            })
            .catch((err) => {
                self._guiHelper.waiting2(false);
                if(err.pluginDiagnostic) {
                    err.pluginDiagnostic.showDiagnostic(self._guiHelper);
                }
                return cb(err);
            });
        return undefined;
    },
    updateApi(_api) {
        const _old = this._api;
        this._api = _api;
        return _old;
    },
    prepareFormSignData(additionalFields, cb) {
        const self = this;
        function init() {
            self.init(function(err) {
                if(err)
                    return reply(err);
                login();
                return undefined;
            });
        }
        function login() {
            const password = additionalFields.password;
            if(!password) {
                return getCertificate();
            }
            nephalemsignerApi.send('Login', { pin: password }, {}, function(err, data) {
                if(err)
                    return reply(err);
                getCertificate();
                return undefined;
            });
            return undefined;
        }
        function getCertificate() {
            //user may be entering PIN, so no timeout
            nephalemsignerApi.send('GetCert', {}, { timeout: 0 }, function(err, data) {
                if(err)
                    return reply(err);
                self.certificate = data.data;
                fillForm();
                return undefined;
            });
        }
        function fillForm() {
            additionalFields.certificate = self.certificate;
            //if we don't pass PIN to server, it will not be remembered inside form data
            //and it will not be passed to next page (autosign will not work)
            //delete additionalFields.password;
            reply();
        }
        function reply(err) {
            cb(err);
        }
        init();
    },
    finalizeSignature(signatureData, options, cb) {
        const self = this;
        //now we got digest, and page saved partially signed document, let's finalize signature
        function signDigest() {
            const params = {
                type: signatureData.digestAlgor,
                digest: signatureData.digest,
            };
            //user may be entering PIN, so no timeout
            nephalemsignerApi.send('Sign', params, { timeout: 0 }, function(err, data) {
                if(err)
                    return reply(err);
                applySignature(data.signature);
                return undefined;
            });
        }
        function applySignature(signature) {
            const pluginDiagnostic = nephalemsignerApi.pluginDiagnostic;
            const userEnvironment = {
                nephalemPluginVersion: pluginDiagnostic.getCurrentVersion('info_plugin'),
                nephalemExtensionVersion: pluginDiagnostic.getCurrentVersion('info_extension'),
                browserVersion: pluginDiagnostic.getCurrentVersion('info_browser'),
                dsproVersion: pluginDiagnostic.getCurrentVersion('info_dspro'),
            };
            //we finalize signature using specific handler dynamic action
            const signActionParams = {
                uid: signatureData.uid,
                signature,
                userEnvironment,
            };
            const params = {
                'dynamic-action': 'sign-qualified-handler-action',
                'signAction': 'finalizeSignature',
                'signActionParams': JSON.stringify(signActionParams),
            };
            self._api.dynamicAction(params, { errors: true, waiting: options.waiting, noalert: true }, function(err, data) {
                if(err)
                    return reply(err);
                //document is changed after this step
                signatureData.documentChanged = data.documentChanged;
                //put other properties (canMoveToNextPage for doclist)
                signatureData.canMoveToNextPage = data.canMoveToNextPage;
                reply();
                return undefined;
            });
        }
        function reply(err) {
            if(err)
                cb(err);
            cb(null, signatureData);
        }
        signDigest();
    },
    handleLocalAction(action, params, cb) {
        if(action != 'configureReader')
            return cb(null, false);

        const self = this;
        function init() {
            self.init(function(err) {
                if(err)
                    return reply(err);
                configure();
                return undefined;
            });
        }
        function configure() {
            //function will not exit while dialog is shown, so no timeout
            nephalemsignerApi.send('Config', {}, { timeout: 0 }, function(err, data) {
                if(err)
                    return reply(err);
                reply();
                return undefined;
            });
        }
        function reply(err) {
            if(err)
                return cb(err);
            cb(null, true);
            return undefined;
        }
        init();
        return undefined;
    },
};

export default {
    'local_pkcs11': LocalPkcs11SignatureHandler,
};
